function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "line",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m56.01 35.82-6.65-7.48a1.00077 1.00077 0 0 0 -.74-.33h-33.24a1.00077 1.00077 0 0 0 -.74.33l-6.65 7.48a1.01135 1.01135 0 0 0 .56006 1.65l5.83 1.09v16.62a.99436.99436 0 0 0 .79.97l16.60994 3.74a.82224.82224 0 0 0 .43994 0l16.61-3.74a.99436.99436 0 0 0 .79-.97v-16.62l5.83-1.09a1.01134 1.01134 0 0 0 .56006-1.65zm-45.35.01 5.17-5.82h14.99l-2.83 9.07zm20.34 21.84-14.62-3.29v-15.44l12.11 2.27a1.00072 1.00072 0 0 0 1.14-.69l1.37-4.38zm16.62-3.29-14.62 3.29v-21.53l1.37 4.38a1.00826 1.00826 0 0 0 1.14.69l12.11-2.27zm-11.61-15.3-2.83-9.07h14.99l5.17 5.82z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 26.85205a.99876.99876 0 0 0 .74414-.332c.83008-.92481 8.10645-9.166 8.10645-13.75244a8.85059 8.85059 0 1 0 -17.70118 0c0 4.58642 7.27637 12.82763 8.10645 13.75244a.99876.99876 0 0 0 .74414.332zm0-20.93555a6.85857 6.85857 0 0 1 6.85059 6.85108c0 2.90869-4.41895 8.7041-6.85059 11.5625-2.43164-2.8584-6.85059-8.65381-6.85059-11.5625a6.85857 6.85857 0 0 1 6.85059-6.85108z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.00012 7.68262c-6.5896.20838-6.59112 9.76617-.00012 9.97558 6.58948-.20843 6.591-9.7662.00012-9.97558zm-.00012 2a2.988 2.988 0 0 1 .00006 5.97558 2.988 2.988 0 0 1 -.00006-5.97558z",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileEmployees);
export default __webpack_public_path__ + "static/media/mobile_employees.1badeac6337b2671b4a496ae48ec84f9.svg";
export { ForwardRef as ReactComponent };